import { useMsal } from "@azure/msal-react";
import { loginApiRequest } from "../msal/authConfig";

export const SignInModal = (): JSX.Element => {
  const { instance } = useMsal();

  return <>{instance.loginRedirect(loginApiRequest)}</>
};